// @ts-nocheck

import { useMemo } from 'react';

import { externalLinkOpen } from '../../../../actions/externallink';
import useBindActionsCreator from '../../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../../hooks/useMergeProps';
import GridsDesktopSubMenu from '../../components/menu/GridsDesktopSubMenu';

const GridsDesktopSubMenuContainer = () => {
  const actions = useMemo(
    () => ({
      openExternalLink: externalLinkOpen,
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ actionsProps });
  return <GridsDesktopSubMenu {...enhancedProps} />;
};

export default GridsDesktopSubMenuContainer;
